import { Navigate, Route, Routes } from "react-router-dom";
import Monitoring from "./monitoring";
import ControlTowerAppointmentsRoutes from "./appointments/routes";
import MaintenanceMonitoring from "./maintenanceMonitoring";
import Budgets from "./budgets";
import BudgetsKanbanPage from "./budgetsKanban";

const ControlTowerRoutes = (props: any) => (
  <Routes>
    <Route path="/" element={<Navigate to="/control-tower/monitoring" />} />
    <Route path="/monitoring" element={<Monitoring {...props} />} />
    <Route
      path="/maintenance-monitoring"
      index
      element={<MaintenanceMonitoring {...props} />}
    />
    <Route
      path="/appointments/*"
      index
      element={<ControlTowerAppointmentsRoutes {...props} />}
    />
    <Route path="/budgets/*" element={<Budgets {...props} persona="control-tower" />} />
    <Route path="/budgets-kanban" element={<BudgetsKanbanPage {...props} />} />
  </Routes>
);

export default ControlTowerRoutes;
